/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState } from 'react'
import { useAlert } from 'react-alert'

import { useModalBox } from '../../../../contexts'
import { Button } from '../../../../components'

const DeleteCardModal = ({ item }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()

  const handleDeleteCard = async (id: number) => {
    try {
      setLoading(true)
      /* await deleteCard({
        id: id
      }).delete() */

      modalClose(true)
      alert.show('Cartão deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar um cartão', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="delete-modal">
      <p>
        Deseja realmente deletar este cartão com final {item.ultimos4digitos}?
      </p>
      <div>
        <Button
          hasredButton
          onClick={() => handleDeleteCard(item.id)}
          disabled={loading}
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default DeleteCardModal
